import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, Redirect } from 'react-router'
import { ApplicationState } from '../../store'
import BottomBar from '../Home/BottomBar'
import Topbar from '../Home/Topbar'
import SetTheme from '../../utils/SetTheme'
import { makePath } from '../../helpers/path'
import { requestUserDone, requestUserFailed } from '../../store/user/user.actions'
import AuthService from '../../services/auth'
import LoadingLayout from '../Layout/LoadingLayout'

const HomeLayout: FC = ({ children }) => {
	const location = useLocation();
	const prefixState = useSelector((state: ApplicationState) => state.prefix)
	const userState = useSelector((state: ApplicationState) => state.user)
	const loc = useLocation()

	const dispatch = useDispatch()
	const requestAuthState = useCallback(async () => {
		try {
			const res = await AuthService.getMemberInfo()
			dispatch(requestUserDone(res))
		} catch {
			localStorage.removeItem('x-auth')
			dispatch(requestUserFailed())
		}
	}, [dispatch])

	useEffect(() => {
		requestAuthState()
	}, [requestAuthState])

	if (!userState.isLoaded) {
		return (
			<LoadingLayout prefix={prefixState} />
		)
	}

	if (userState.isLoaded && userState.info) {
		return <Redirect to={makePath('/wallet')} />
	}
	return (
		<>
			<SetTheme />

			<Topbar
				prefix={prefixState.info}
				member={userState.info}
				pathname={loc.pathname}
			/>

			<div className='content'>
				{children}
			</div>
			{location.pathname === '/home' && <BottomBar prefix={prefixState.info} />}
			
		</>
	)
}

export default HomeLayout
